export enum TipoDocEnum {
  OrdineAcqVen = 1,
  OrdineCLavoro = 2,
  OrdineSpedizione = 3,
  DdtAcqVen = 4,
  Mandati = 5,
  PrevAcqVen = 6,
  DdtATerz = 7,
  FaseOdP = 8,
  OrdineAcq = 9
}

export const TIPO_DOC = [
  { value: TipoDocEnum.OrdineAcqVen, text: 'Ordine di acquisto/vendita', newValue: ''},
  { value: TipoDocEnum.OrdineCLavoro, text: 'Ordine di C/lavoro', newValue: '' },
  { value: TipoDocEnum.OrdineSpedizione, text: 'Ordine di spedizione', newValue: '' },
  { value: TipoDocEnum.DdtAcqVen, text: 'Ddt di acquisto/vendita', newValue: '' },
  { value: TipoDocEnum.Mandati, text: 'Mandati di fatturazione attivi/passivi', newValue: '' },
  { value: TipoDocEnum.PrevAcqVen, text: 'Preventivi di acquisto/vendita', newValue: '' },
  { value: TipoDocEnum.DdtATerz, text: 'Ddt a terzista con riga ordine', newValue: '' },
  { value: TipoDocEnum.FaseOdP, text: 'Fase OdP', newValue: '' },
  { value: TipoDocEnum.OrdineAcq, text: 'Ordine di acquisto', newValue: '' },
];
